export var Products;
(function (Products) {
    Products["ILE"] = "ILE";
    Products["Spanish"] = "Spanish";
    Products["IM"] = "IM";
    Products["IMF"] = "IMF";
    Products["Galileo"] = "Galileo";
    Products["AdaptiveAssessment"] = "AdaptiveAssessment";
    Products["MyPathMath"] = "MyPathMath";
    Products["MyPathReading"] = "MyPathReading";
    Products["Purpose"] = "Purpose";
    Products["Traverse"] = "Traverse";
    Products["MyPathPortal"] = "MyPathPortal";
    Products["IPA"] = "IPA";
    Products["Dragonfly"] = "Dragonfly";
    Products["StudySync"] = "StudySync";
    Products["ImagineIM"] = "ImagineIM";
    Products["IllustrativeMathematics"] = "IllustrativeMathematics";
    Products["ELEducation"] = "ELEducation";
    Products["Guidebooks"] = "Guidebooks";
    Products["OdellEducation"] = "OdellEducation";
})(Products || (Products = {}));
